import { Fragment, useEffect, useState } from 'react'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import Logo from '../images/Logo.png'
import { links } from '../data'
import { VscThreeBars } from 'react-icons/vsc'
import { MdOutlineClose } from 'react-icons/md'

import './navbar.css'
import { Alert, Button, CircularProgress, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Modal, Select, Snackbar, TextField } from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material';
import axiosInstance from '../utils/axiosInstance'



const Navbar = () => {
    const [isNavShowing, setIsNavShowing] = useState(false);
    const [open, setOpen] = useState(false);
    const [isJoinOpen, setIsJoinOpen] = useState(false);
    const [roleSelection, setRoleSelection] = useState('guest');
    const [signIn, setSignIn] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const navigate = useNavigate()
    const auth = localStorage.getItem('gym_user') ? JSON.parse(localStorage.getItem('gym_user')) : null;
    const [myLink, setMyLink] = useState('')
    const [login, setLogin] = useState({
        email: '',
        password: ''
    });

    const [user, setUser] = useState({
        name: '',
        email: '',
        phone: '',
        durations: '',
        height: '',
        size: 'S',
        weight: '',
        password: '',
    })

    const handleLogout = () => {
        localStorage.removeItem('gym_user');
        navigate('/');
    }

    const handleSignInOpen = () => {
        setSignIn(true);
    };

    const handleSignInClose = () => {
        setSignIn(false);
    };


    const handleTogglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleChangeRole = (e) => {
        setRoleSelection(e.target.value);
    }

    const handleLogin = async (e) => {
        e.preventDefault();
        setOpen(true);
        setLoading(true)

        if (!roleSelection) {
            setMessage("Please select a role before submitting");
            return;
        } else if (login.email === "") {
            setMessage("Please enter your email");
            return;
        } else if (login.password === "") {
            setMessage("Please enter your password");
            return;
        }

        if (roleSelection === 'guest') {
            await axiosInstance.post(`guests/login`, login, {
                headers: { 'Content-Type': 'application/json' }
            }).then((response) => {
                setMessage(`Success, welcome to fitness.`)

                const guest = response.data.guest;
                localStorage.setItem('gym_user', JSON.stringify(guest));
                setTimeout(() => {
                    setLogin({
                        email: '',
                        password: ''
                    })
                    setOpen(false);
                    setLoading(false)
                    handleSignInClose()
                    navigate(`/trainee/${guest.guest_id}/profile/guest`)
                }, 3000)
            }).catch((error) => {
                if (error.status === 400) {
                    setMessage(`Failure, ${error.response.data.error}`)
                } else if(error.status === 404) {
                    setMessage(`Failure! User not found as a guest, try as a member or instructor.`)
                } else {
                    setMessage(`Failure! ${error.response.data.error}`)
                }
                // console.log(error.response.data)
                setTimeout(() => {
                    // setOpen(false)
                    setLoading(false)
                }, 3000);
            })
        } else if (roleSelection === 'member') {
            await axiosInstance.post(`membership/login`, login, {
                headers: { 'Content-Type': 'application/json' }
            }).then((response) => {
                setMessage(`Success, welcome to fitness.`);

                const member = response.data.member
                localStorage.setItem('gym_user', JSON.stringify(member));
                setTimeout(() => {
                    setLogin({
                        email: '',
                        password: ''
                    })
                    setOpen(false);
                    setLoading(false)
                    handleSignInClose()
                    navigate(`/trainee/${member.member_id}/profile/member`)
                }, 3000)
            }).catch((error) => {
                if (error.status === 400) {
                    setMessage(`Failure, ${error.response.data.error}`)
                } else if(error.status === 404) {
                    setMessage(`Failure! User not found as a member, try as a guest or instructor.`)
                } else {
                    setMessage(`Failure! ${error.response.data.error}`)
                }
                // console.log(error.response.data)
                setTimeout(() => {
                    // setOpen(false)
                    setLoading(false)
                }, 3000);
            })
        } else if (roleSelection === 'instructor') {
            await axiosInstance.post(`instructors/login`, login, {
                headers: { 'Content-Type': 'application/json' }
            }).then((response) => {
                setMessage(`Success, welcome to fitness.`);

                const instructor = response.data.instructor
                localStorage.setItem('gym_user', JSON.stringify(instructor));
                setTimeout(() => {
                    setLogin({
                        email: '',
                        password: ''
                    })
                    setOpen(false);
                    setLoading(false)
                    handleSignInClose()
                    navigate(`/profile/${instructor.instructor_id}/trainer`)
                }, 3000)
            }).catch((error) => {
                if (error.status === 400) {
                    setMessage(`Failure, ${error.response.data.error}`)
                } else if(error.status === 404) {
                    setMessage(`Failure! User not found as an instructor, try as a guest or member.`)
                } else {
                    setMessage(`Failure! ${error.response.data.error}`)
                }
                // console.log(error.response.data)
                setTimeout(() => {
                    // setOpen(false)
                    setLoading(false)
                }, 3000);
            })
        }
    }

    const handleRegister = async () => {
        setOpen(true)
        if(!roleSelection) {
            setMessage("Please select a role before submitting");
            return;
        }

        if (roleSelection === 'guest') {
            await axiosInstance.post(`guests/create`, user, {
                headers: { 'Content-Type': 'application/json' }
            }).then(() => {
                setMessage(`Success, successfully registered as guest named ${user.name}`)
                setTimeout(() => {
                    setOpen(false);
                    setUser({})
                    setIsJoinOpen(false)
                }, 3000)
            }).catch((error) => {
                if (error.response && error.response.data.error) {
                    setMessage(`Failure, ${error.response.data.error}`)
                } else {
                    setMessage(`Failure, ${error}`)
                }
                setTimeout(() => { setOpen(false) }, 3000);
            })
        } else if (roleSelection === 'member') {
            await axiosInstance.post(`membership/create`, user, {
                headers: { 'Content-Type': 'application/json' }
            }).then(() => {
                setMessage(`Success, successfully registered as member named ${user.name}`)
                setTimeout(() => {
                    setOpen(false);
                    setUser({})
                    setIsJoinOpen(false)
                }, 3000)
            }).catch((error) => {
                if (error.response && error.response.data.error) {
                    setMessage(`Failure, ${error.response.data.error}`)
                } else {
                    setMessage(`Failure, ${error}`)
                }
                setTimeout(() => { setOpen(false) }, 3000);
            })
        }
    }

    useEffect(() =>{
        const link = 
        auth && auth.guest_id
            ? `/trainee/${auth.guest_id}/profile/guest`
            : auth && auth.member_id
            ? `/trainee/${auth.member_id}/profile/member`
            : auth && auth.instructor_id
            ? `/profile/${auth.instructor_id}/trainer`
            : auth && auth.user_id
            ? `/account`
            : '/';

        setMyLink(link)
    }, [auth])

    return (
        <nav>
            <div className="container nav__container">
                <Link to="/" className='logo' onClick={() => setIsNavShowing(false)}>
                    <img src={Logo} alt="Nav Logo" />
                </Link>
                <ul className={`nav__links ${isNavShowing ? 'show__nav' : 'hide_Nav'}`}>
                    {links.map(({ name, path }, index) => {
                        if (index < links.length - 3) {
                            return (
                                <li key={index}>
                                    <NavLink to={path} className={({ isActive }) => (isActive ? 'active-nav' : '')} onClick={() => setIsNavShowing((prev) => !prev)}>
                                        {name}
                                    </NavLink>
                                </li>
                            );
                        } else {
                            // Handle action buttons (Join, Signin, Logout)
                            if (!auth) {
                                // Show Join and Signin buttons if not authenticated
                                if (name === "Join") {
                                    return (
                                        <li key={index} className="join__button" onClick={() => setIsJoinOpen(true)}>
                                            {name}
                                        </li>
                                    );
                                }
                                if (name === "Signin") {
                                    return (
                                        <li key={index} className="join__button" onClick={handleSignInOpen}>
                                            {name}
                                        </li>
                                    );
                                }
                            } else {
                                // Show Logout button if authenticated
                                if (name === "Logout") {
                                    return (
                                        <Fragment key={index}>
                                            <li >
                                                <NavLink to={myLink} className={({ isActive }) => (isActive ? 'active-nav' : '')} onClick={() => setIsNavShowing(false)}>
                                                    Profile
                                                </NavLink>
                                            </li>
                                            <li className="rounded-lg bg-red-600 p-2 px-5 text-white cursor-pointer" onClick={handleLogout}>
                                                {name}
                                            </li>
                                        </Fragment>
                                    );
                                }
                            }
                        }
                        return null;
                    })}
                </ul>

                <button className="nav-toggle-btn" onClick={() => setIsNavShowing(prev => !prev)}>
                    {
                        isNavShowing ? <MdOutlineClose /> : <VscThreeBars />
                    }
                </button>
            </div>

            <Modal open={isJoinOpen} onClose={() => setIsJoinOpen(false)} className='flex items-center justify-center w-full' aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='bg-white w-[90%] lg:w-[40%] shadow p-8 rounded-sm'>
                    <h2 className='text-blue-950 mb-8'>
                        {`Join`}
                    </h2>
                    <form>
                        <TextField fullWidth label="Your Name" type='text' variant="outlined" style={{ marginBottom: '16px' }} value={user.name} onChange={(e) => setUser((prev) => ({ ...prev, name: e.target.value }))} />
                        <TextField fullWidth label="Email Address" type="email" variant="outlined" style={{ marginBottom: '16px' }} value={user.email} onChange={(e) => setUser((prev) => ({ ...prev, email: e.target.value }))} />
                        <TextField fullWidth label="Phone Number" type="tel" variant="outlined" style={{ marginBottom: '16px' }} value={user.phone} onChange={(e) => setUser((prev) => ({ ...prev, phone: e.target.value }))} />
                        <FormControl fullWidth>
                            <InputLabel>Select role</InputLabel>
                            <Select label="Select role" value={roleSelection} onChange={handleChangeRole}>
                                <MenuItem value="guest">
                                    Guest
                                </MenuItem>
                                <MenuItem value="member">
                                    Member
                                </MenuItem>
                            </Select>
                        </FormControl>
                        {roleSelection === 'member' && (
                            <>
                                <TextField fullWidth label="Duration in weeks" type="number" variant="outlined" style={{ margin: '16px 0px' }} value={user.durations} onChange={(e) => setUser((prev) => ({ ...prev, durations: e.target.value }))} />
                                <TextField fullWidth label="Height" type="number" variant="outlined" style={{ marginBottom: '16px' }} value={user.height} onChange={(e) => setUser((prev) => ({ ...prev, height: e.target.value }))} />
                                <TextField fullWidth label="Weight" type="number" variant="outlined" style={{ marginBottom: '16px' }} value={user.weight} onChange={(e) => setUser((prev) => ({ ...prev, weight: e.target.value }))} />
                                <FormControl fullWidth>
                                    <InputLabel>Size</InputLabel>
                                    <Select label="Select Size" value={user.size} onChange={(e) => setUser((prev) => ({ ...prev, size: e.target.value }))}>
                                        <MenuItem value="S">
                                            Small
                                        </MenuItem>
                                        <MenuItem value="M">
                                            Medium
                                        </MenuItem>
                                        <MenuItem value="L">
                                            Large
                                        </MenuItem>
                                        <MenuItem value="XL">
                                            Extra Large
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </>
                        )}
                        <TextField fullWidth label="Enter password" type={showPassword ? 'text' : 'password'} value={user.password} onChange={(e) => setUser((prev) => ({ ...prev, password: e.target.value }))} variant="outlined" style={{ marginTop: '16px' }} InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleTogglePasswordVisibility} edge="end">
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }} />
                        <div className='flex gap-4 mx-auto w-[80%] mt-4'>
                            <Button variant="contained" color="primary" fullWidth className='mt-4' onClick={handleRegister}>
                                JOIN NOW
                            </Button>
                            <Button variant="contained" color="error" onClick={() => setIsJoinOpen(false)} fullWidth className='mt-4'>
                                Cancel
                            </Button>
                        </div>
                    </form>
                </div>
            </Modal>

            <Modal open={signIn} onClose={handleSignInClose} className='flex items-center justify-center w-full' aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <div className='bg-white w-[90%] lg:w-[40%] shadow p-8 rounded-sm'>
                    <h2 className='text-blue-950 mb-8'>
                        {`Sign in`}
                    </h2>
                    <form>
                        <TextField fullWidth label="Email Address" required type="email" value={login.email} onChange={(e) => setLogin((prev) => ({ ...prev, email: e.target.value }))} variant="outlined" style={{ marginBottom: '16px' }} />
                        <FormControl fullWidth required>
                            <InputLabel>Select role</InputLabel>
                            <Select label="Question Type" value={roleSelection} onChange={(e) => setRoleSelection(e.target.value)}>
                                <MenuItem value="guest">
                                    Guest
                                </MenuItem>
                                <MenuItem value="member">
                                    Member
                                </MenuItem>
                                <MenuItem value="instructor">
                                    Instructor
                                </MenuItem>
                            </Select>
                        </FormControl>
                        <TextField fullWidth label="Enter password" required type={showPassword ? 'text' : 'password'} value={login.password} onChange={(e) => setLogin((prev) => ({ ...prev, password: e.target.value }))} variant="outlined" style={{ marginTop: '16px' }} InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={handleTogglePasswordVisibility} edge="end">
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }} />
                        <div className='flex gap-4 mx-auto w-[80%] mt-4'>
                            {loading ?
                                <Button disabled variant="contained" color="primary" fullWidth className='mt-4'>
                                    <CircularProgress size={5} />
                                </Button>
                                :
                                <Button disabled={!login.email || !login.password || !roleSelection} variant="contained" color="primary" fullWidth className='mt-4' onClick={handleLogin}>
                                    Sign In
                                </Button>
                            }
                            <Button variant="contained" color="error" onClick={handleSignInClose} fullWidth className='mt-4'>
                                Cancel
                            </Button>
                        </div>
                    </form>
                </div>
            </Modal>

            <Snackbar open={open} autoHideDuration={10000} onClose={() => setOpen(false)} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Alert color={message.startsWith("Success") ? 'success' : message.startsWith('Failure') ? 'error' : message.startsWith('Warning') ? 'warning' : 'info'}>{message}</Alert>
            </Snackbar>
        </nav>
    )
}

export default Navbar